import styled, { Scale } from '@secretescapes/falcon';
import { mediaQuery } from '@utils/styles.utils';
import { PAGE_CONTAINER_WIDTH } from '../SalePageDesktop.utils';

export const SectionContainer = styled('section')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.l};
  margin: unset;
  width: 100%;
  max-width: ${PAGE_CONTAINER_WIDTH}px;

  box-sizing: border-box;
  padding-top: ${Scale.xl};

  &.full-width {
    max-width: 100%;
    background-color: ${({ theme }) => theme.color.grey05};
    padding: ${Scale.xl} calc((100% - ${PAGE_CONTAINER_WIDTH}px) / 2);

    @media ${mediaQuery.tablet} {
      padding: ${Scale.xl} ${Scale.m};
    }
  }

  @media ${mediaQuery.tablet} {
    padding: ${Scale.xl} ${Scale.m} 0;
  }
`;
